<template>
    <v-container>
        <template v-if="description">
            <v-row class="font-weight-bold text-body-1">
                <slot name="title" v-if="!hideTitle">
                    <div class="py-2">
                    {{ title }}
                    </div>
                </slot>
            </v-row>
            <v-row>
                <div class="text-body-2 py-2">
                {{ description }}
                </div>
            </v-row>
        </template>
        <template v-else>
            <v-row class="font-weight-bold text-body-1">
                <slot name="title">
                    <div class="py-2">
                    {{ title }}
                    </div>
                </slot>
            </v-row>
        </template>
        <v-row class="mb-3">
            <v-divider v-if="!hideDivider" />
        </v-row>
        <v-row>
            <slot name="contents"></slot>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'CaptionContents',
    model: {
        prop: 'text'
    },
    props:{
        description: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        hideDivider: {
            type: Boolean,
            default: false
        },
        hideTitle: {
            type: Boolean,
            default: false
        }
    },
}
</script>